import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { useTranslation } from "react-i18next"

import { InfiniteScrollLoading } from "components"
import RrTableRow from "./RrTableRow"
import classes from "./RrTable.module.scss"

const RrTable = (props) => {
  const {
    dispatchedOrders,
    hasMore,
    skip,
    loadMore
  } = props

  const [t] = useTranslation()

  return (
    <div
      id="scrollable-div"
      className={classes["table-container"]}
    >
      <InfiniteScroll
        hasMore={hasMore}
        dataLength={skip}
        next={loadMore}
        style={{ overflow: "unset" }}
        scrollableTarget="scrollable-div"
        loader={<InfiniteScrollLoading />}
        scrollThreshold="100px"
      >
        <table className={classes["table"]}>
          <thead>
            <tr>
              <th>{t("نام_مشتری")}</th>
              <th>{t("شماره_سفارش")}</th>
              <th>{t("تاریخ_ثبت_سفارش")}</th>
              <th>{t("تاریخ_تایید_سفارش")}</th>
              <th>{t("محصولات_خریداری_شده")}</th>
              <th>{t("گزارش_وضعیت_سفارش")}</th>
              <th>{t("اطلاعات_طریق_سفارش")}</th>
              <th>{t("تاریخ_خروج")}</th>
              <th>{t("نام_انباردار")}</th>
            </tr>
          </thead>
          <tbody>
            {dispatchedOrders.map((dispatchedOrder) =>
              <RrTableRow
                key={dispatchedOrder._id}
                dispatchedOrder={dispatchedOrder}
              />
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  )
}

export default RrTable